module.exports = __webpack_public_path__ + "static/hmi-9a906ab479a9cd7f3f5d087f6f51b2c0.png";